import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

interface ShiftCancelHeaderProps {
  isWorkerRestricted?: boolean;
  isZeroPointsCancellation?: boolean;
  verticallyCenter?: boolean;
}

function getSubtitle(props: {
  isWorkerRestricted?: boolean;
  isZeroPointsCancellation?: boolean;
}): string {
  const { isWorkerRestricted, isZeroPointsCancellation } = props;

  if (isWorkerRestricted) {
    return "Showing up helps you remain in good standing with the workplace who has invited you!";
  }

  if (isZeroPointsCancellation) {
    return "This won't affect your Clipboard Score";
  }

  return "How this will impact your Clipboard Score";
}

export function ShiftCancelHeader(props: ShiftCancelHeaderProps): JSX.Element {
  const { isWorkerRestricted, isZeroPointsCancellation, verticallyCenter } = props;

  const subtitle = getSubtitle({ isWorkerRestricted, isZeroPointsCancellation });

  return (
    <Stack
      spacing={2}
      alignItems="center"
      sx={{
        paddingTop: 12,
        paddingBottom: 6,
        paddingX: 6,
        flexGrow: verticallyCenter ? 1 : 0,
        justifyContent: "center",
      }}
    >
      <Text
        variant="h2"
        color={(theme) => theme.palette.intent?.error.text}
        sx={{ textAlign: "center" }}
      >
        Cancel your shift?
      </Text>
      <Text
        variant="h6"
        color={(theme) => theme.palette.text.secondary}
        sx={{ textAlign: "center" }}
      >
        {subtitle}
      </Text>
    </Stack>
  );
}
